<div *ngIf="(field && textVerify(erros) || (field && textErroServer))" class="pt-1">
  <small *ngIf="textErroServer; else textStatic" class="msg-field-required">
    {{ textErroServer }}
  </small>

  <ng-template #textStatic>
    <small class="msg-field-required">
      {{ text }}
    </small>
  </ng-template>
</div>